import { render } from "./SpeakerManager.vue?vue&type=template&id=220a3ecc&scoped=true"
import script from "./SpeakerManager.vue?vue&type=script&lang=js"
export * from "./SpeakerManager.vue?vue&type=script&lang=js"

import "./SpeakerManager.vue?vue&type=style&index=0&id=220a3ecc&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-220a3ecc"]])

export default __exports__